import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useStore, extractErrorMessage } from "../../../helpers";
import { TARS_CONTEXTS_CREATE_PATH } from "../tars-constants";
import { markTarsNotebookActivity } from "./tars-notebook-last-touched";

export interface CreateContextPayload {
  notebook_id: number;
  context: string;
  /** Optional. Omit to create next version. */
  version?: number;
}

export interface CreateContextResponse {
  id?: number;
  notebook_id?: number;
  context?: string;
  [key: string]: unknown;
}

export const useCreateContext = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateContextPayload): Promise<CreateContextResponse> => {
      const res = await rootStore.apiRequestHandler(
        TARS_CONTEXTS_CREATE_PATH,
        { ...payload },
        "Failed to create context"
      );
      return (res.data ?? res) as CreateContextResponse;
    },
    onSuccess: (_data, variables) => {
      toast.success("Context saved successfully");
      markTarsNotebookActivity(queryClient, variables.notebook_id);
      queryClient.invalidateQueries({ queryKey: ["tars", "contexts"] });
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to create context"));
    },
  });
};
